var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.4166 6.17464V18.333H3.39993C2.43327 18.333 1.6416 17.558 1.6416 16.608V4.24131C1.6416 2.05797 3.27494 1.06631 5.2666 2.04131L8.95827 3.86631C9.75827 4.25797 10.4166 5.29964 10.4166 6.17464Z",
    fill: "#B90022"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47467 8.125H4.58301C4.24134 8.125 3.95801 7.84167 3.95801 7.5C3.95801 7.15833 4.24134 6.875 4.58301 6.875H7.47467C7.81634 6.875 8.09967 7.15833 8.09967 7.5C8.09967 7.84167 7.82467 8.125 7.47467 8.125Z",
    fill: "#B90022"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47467 11.4585H4.58301C4.24134 11.4585 3.95801 11.1752 3.95801 10.8335C3.95801 10.4918 4.24134 10.2085 4.58301 10.2085H7.47467C7.81634 10.2085 8.09967 10.4918 8.09967 10.8335C8.09967 11.1752 7.82467 11.4585 7.47467 11.4585Z",
    fill: "#B90022"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M18.3337 12.5414V16.2498C18.3337 17.3998 17.4003 18.3331 16.2503 18.3331H10.417V8.68311L10.8087 8.76644L14.1753 9.51644L14.5753 9.60811L16.2753 9.99144C16.6837 10.0748 17.0587 10.2164 17.3837 10.4248C17.3837 10.4331 17.392 10.4331 17.392 10.4331C17.4753 10.4914 17.5587 10.5581 17.6337 10.6331C18.017 11.0164 18.267 11.5748 18.3253 12.3914C18.3253 12.4414 18.3337 12.4914 18.3337 12.5414Z",
    fill: "#B90022"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.417 8.68311V13.6831C10.8003 14.1914 11.4003 14.5164 12.0837 14.5164C13.242 14.5164 14.1753 13.5831 14.1753 12.4331V9.52477L10.8087 8.77477L10.417 8.68311Z",
    fill: "#B90022"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3248 12.3916C18.2665 11.5749 18.0165 11.0166 17.6331 10.6333C17.5581 10.5583 17.4748 10.4916 17.3915 10.4333C17.3915 10.4333 17.3831 10.4333 17.3831 10.4249C17.0581 10.2166 16.6831 10.0749 16.2748 9.9916L14.5748 9.60827L14.1748 9.5166V12.4333C14.1748 13.5749 15.0998 14.5166 16.2581 14.5166C17.3748 14.5166 18.2665 13.6416 18.3331 12.5499V12.5416C18.3331 12.4916 18.3248 12.4416 18.3248 12.3916Z",
    fill: "#B90022"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.7578aa3feb7dc640cf0cec250946eb84.svg";
export { ForwardRef as ReactComponent };